import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_DASHBOARD_BILLING_SUMMARY } from 'services/billing/GetDashboardBillingSummary';
import DashboardBillingError from './DashboardBillingError';
import DashboardBillingInfo from './DashboardBillingInfo';
import useNavigationAnalytics from 'hooks/useNavigationAnalytics';
import { AnalyticsEvent } from 'services/AnalyticsService';
import { MuiGrid } from 'theme/material-ui';

export const DashboardBilling = () => {
  const analyticsOnError = useNavigationAnalytics(AnalyticsEvent.DashboardBillingFetchError);
  const {
    data: guarantorData,
    loading: guarantorLoading,
    error: guarantorError
  } = useQuery(GET_DASHBOARD_BILLING_SUMMARY, { errorPolicy: 'all' });
  const { amountDue, dueStatus, totalEncounters } = guarantorData?.guarantor || {};

  useEffect(() => {
    if (guarantorError) analyticsOnError();
  }, [guarantorError]);

  if (guarantorLoading) return null;
  if (totalEncounters === 0) return null;
  if (guarantorError)
    return (
      <MuiGrid item xs={12} md={6}>
        <DashboardBillingError />
      </MuiGrid>
    );

  return (
    <MuiGrid item xs={12} md={6}>
      <DashboardBillingInfo
        amountDue={amountDue}
        numberOfStatements={totalEncounters}
        dueStatus={dueStatus}
      />
    </MuiGrid>
  );
};

export default DashboardBilling;
